export default "__VITE_ASSET__BtpWbjal__"